export class Preview {
    constructor(element, overlay) {
        if (typeof element !== 'undefined') {
            const images = [...element.querySelectorAll('img')];
            images.forEach((image, index) => image.addEventListener('click', () => {
                if (document.querySelector('.mgnlEditorBar')) {
                    alert('Not supported in Editor-Mode')
                    return
                }
                overlay.open(index)
            }));
        }
    }
}
